import React from 'react'
//import moment from 'moment-timezone'
import { Icon, Table, Segment, Step} from 'semantic-ui-react'



const Result = ({ result, filterero, handleClick, handleSeriesClick, handleSeuraClick,
   handleLahtoClick, handleSijaClick, handleMaaliClick, handleEroClick, handleKerratClick}) => {
  
  const IconNotice = ({result, handleSijaClick}) =>  {
    if ( Number(result.space) === 1 ) {
      return (
        <Table.Cell textAlign="right"><Icon color='red' name='attention' onClick={handleSijaClick}></Icon>{result.space}</Table.Cell>
      )
    }
    else if ( Number(result.space) === 2) {
      return (
        <Table.Cell textAlign="right"><Icon color='blue' name='attention' onClick={handleSijaClick}></Icon>{result.space}</Table.Cell>
      )
    }
    else if ( Number(result.space) === 3) {
      return (
        <Table.Cell textAlign="right"><Icon color='grey' name='attention' onClick={handleSijaClick}></Icon>{result.space}</Table.Cell>
      )
    }
    else if ( Number(result.space) <= 10) {
      return (
        <Table.Cell textAlign="right"><Icon color='yellow' name='attention' onClick={handleSijaClick}></Icon>{result.space}</Table.Cell>
      )
    }
    else {
      return (
        <Table.Cell onClick={handleSijaClick} textAlign="right">{result.space}</Table.Cell>
      )
    }
  }

  //const RowNotice = Number(result.space) <= 3 ? {
  //  className: 'negative'
  //}  : {}
  const FormatTimes = (timevalue,pre,post) => {
      const y = timevalue.split(":")
      y[0] = y[0].replace(/^[0]+/g, '')
      if(y[0] === '') {
          y[1] = y[1].replace(/^[0]+/g, '') 
      }
      if(y[1] === '') {
        y[2]= y[2].replace(/^[0]+/g, '')
      }
      const r = y.filter(function(p) {return p!=='';}).join(':');
      return r !== '' ? pre+r+post : ""
    }

  const cEro=filterero !=='' ? FormatTimes(result.cap_to_first.substr(0,8),"+","")+FormatTimes(result.cap_to_prev.substr(0,8),"(+",")") : FormatTimes(result.cap_to_first.substr(0,8),"+","")
  const stylefilterero= filterero !== "" ? {style: {color: 'red' }} : {}
  return ( 
      <>
       <Table.Row onClick={handleClick}>
        <Table.Cell>{result.number}</Table.Cell>
        <Table.Cell>{result.joukkue}</Table.Cell>
        <Table.Cell onClick={handleSeuraClick}>{result.organization}</Table.Cell>
        <Table.Cell onClick={handleLahtoClick} textAlign="right">{FormatTimes(result.timems.substr(0,8),"","")}</Table.Cell>
        <IconNotice result={result} handleSijaClick={handleSijaClick} />
        <Table.Cell onClick={handleSeriesClick}>{result.seriesname}</Table.Cell>
        { filterero !== "ALL"
        ?<><Table.Cell onClick={handleEroClick} textAlign="right">{cEro}</Table.Cell></>
        :<><Table.Cell textAlign="right">{FormatTimes(result.cap_to_first.substr(0,8),"+","")}</Table.Cell>
        <Table.Cell textAlign="right">{FormatTimes(result.cap_to_prev.substr(0,8),"+","")}</Table.Cell></>
        }
        <Table.Cell onClick={handleMaaliClick}>{result.eventtime.substr(11,8)}</Table.Cell>
        </Table.Row>
      </>
  )
}



export default Result